module.exports = __webpack_public_path__ + "assets/img/third_user.e71817dd.png";